import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import MotivosOuvidoriaCard from './components/MotivosOuvidoriaCard';

const MotivosOuvidoriaMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Início' },
            { name: 'Motivos da Ouvidoria' },
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <MotivosOuvidoriaCard />
      </Col>
    </Row>
  </Container>
);

export default MotivosOuvidoriaMain;
